import enumerable from './enum.js';
import pattern from './pattern.js';
import range from './range.js';
import required from './required.js';
import type from './type.js';
import whitespace from './whitespace.js';
var rules = {
  required: required,
  whitespace: whitespace,
  type: type,
  range: range,
  enum: enumerable,
  pattern: pattern
};
export { rules as default };
//# sourceMappingURL=index.js.map
